import SignUpLayout from "@/src/components/template/Layout/SignUpLayout";
import FreeSignupCompleted from "../EnterpriseSignup/components/FreeSignupCompleted";
import styled from "styled-components";

function FreeSignupCompletedPage() {
  return (
    <SignUpLayout>
      <StyledMain>
        <FreeSignupCompleted />
      </StyledMain>
    </SignUpLayout>
  );
}

export default FreeSignupCompletedPage;

const StyledMain = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 800px;
  margin: 0 auto;
  padding: 24px 0;
`;
